import React from 'react';
import { observer } from 'mobx-react-lite';

import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { Edit } from '@insurancemenu/imenu-components-lib/dist/icons';

import AssignAgentsModal from 'components/common/group/content/AssignAgentsModal';
import { useRootStore } from 'store/rootStore';
import ContactBlock from 'components/common/group/sidebar/ContactBlock';
import { adminRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { createStyles } from './styles';

const AssignedInfo = observer((): JSX.Element => {
  const rootStore = useRootStore();
  const {
    groupSidebarStore: {
      group: { agentOfRecord, assigned, accountRepresentative },
    },
  } = rootStore;

  const [showAssignedModal, setShowAssignedModal] = React.useState(false);

  const editAssignedInfo = (): void => {
    setShowAssignedModal(true);
  };

  const onCloseAgentsModal = (): void => {
    setShowAssignedModal(false);
  };

  const classes = createStyles();

  const canEditAssignedInfo =
    !rootStore.domainStoreV2.adminOnlyAgentAssignment ||
    (rootStore.domainStoreV2.adminOnlyAgentAssignment && adminRights(rootStore.userStore.userRoles));

  return (
    <div id="assign-info-section">
      <header className={classes.categoryWrapper}>
        <h3 className={classes.categoryName}>Assigned</h3>
        {canEditAssignedInfo ? (
          <Button
            type="text"
            iconSize="1.6rem"
            color="custom"
            customColor={colors.neutral[900]}
            leftIconProp={<Edit />}
            className={classes.editContactInfo}
            onClick={(): void => editAssignedInfo()}
            id="edit-assign-info"
          >
            {' '}
          </Button>
        ) : null}
      </header>
      <div className={classes.contentWrapper}>
        {agentOfRecord && (
          <div className={classes.contactFieldBox} id="agent-of-record-block">
            <p className={classes.fieldName}>{agentOfRecord.tin ? 'TIN' : 'Agent of Record'}:</p>
            <div className={classes.aorWrapper}>
              <p className={classes.fieldValue}>{agentOfRecord.tin || agentOfRecord.name || '-'}</p>
              {agentOfRecord.name && !agentOfRecord.id && <div className={classes.tag}>Missing</div>}
            </div>
          </div>
        )}
        {assigned && assigned.length > 0 && (
          <div className={classes.contactFieldBox} id="assigned-agents-block">
            <p className={classes.fieldName}>Assigned Agents / Teams:</p>
            <p className={classes.fieldValue}>{assigned && assigned.map((agent) => agent.name).join(', ')}</p>
          </div>
        )}
        {accountRepresentative && (
          <ContactBlock
            blockTitle="Account Representative"
            className={classes.accountRepBlock}
            info={{
              name: `${accountRepresentative.firstName} ${accountRepresentative.lastName}`,
              email: accountRepresentative.email || '',
            }}
          />
        )}
      </div>
      <AssignAgentsModal show={showAssignedModal} onClose={onCloseAgentsModal} isClosable />
    </div>
  );
});

export default AssignedInfo;
